import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initSecureStorage } from "@/utils/secureStorage";

const root = ReactDOM.createRoot(document.getElementById("root"));
initSecureStorage().finally(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});

// -----------------------------------------------------------------
// PWA service worker registration.
// Enables "Add to Home Screen" on Chrome/Edge (and iOS 16.4+), offline
// fallback via /offline.html, and installability. The SW itself lives at
// /public/sw.js and is served from the root scope.
// Registration is a no-op in localhost / preview if the SW file is
// missing (silently swallowed).
// -----------------------------------------------------------------
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* no-op */ });
  });
}
